import { render, staticRenderFns } from "./ModelIncomeSendRecord.vue?vue&type=template&id=7881618f&scoped=true&"
import script from "./ModelIncomeSendRecord.vue?vue&type=script&lang=js&"
export * from "./ModelIncomeSendRecord.vue?vue&type=script&lang=js&"
import style0 from "./ModelIncomeSendRecord.vue?vue&type=style&index=0&id=7881618f&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7881618f",
  null
  
)

export default component.exports